import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MessageBox from 'syf-component-library/ui/patterns/MessageBox';
import Stack from 'syf-component-library/ui/spacing/Stack';
import Body from 'syf-component-library/ui/typography/Body';
import { FAR_EXCLAMATION_TRIANGLE } from '../../../const/iconProps';
import { helpNumbers } from '../../../const/phoneNumbers';
import { t } from '../../../strings/i18n';
const AutopayUnavailableMessage = ({ isBankrupt }) => {
    const phoneNumber = isBankrupt ? helpNumbers.bankruptcy : helpNumbers.general;
    return (_jsxs(_Fragment, { children: [_jsx(Stack, { size: "medium" }), _jsxs(MessageBox, Object.assign({ icon: _jsx(FontAwesomeIcon, { icon: FAR_EXCLAMATION_TRIANGLE, size: "3x" }), type: "warning" }, { children: [_jsx(Body, Object.assign({ weight: "bold" }, { children: t('errors.autopayUnavailable') })), _jsx(Stack, { size: "small" }), _jsx(Body, { children: t('errors.autopayUnavailableInfo', { phoneNumber }) })] }))] }));
};
export default AutopayUnavailableMessage;
